import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { WebhookType } from 'src/app/core/api/models';


@Directive({
  selector: '[webhookType]',
  standalone: true
})
export class WebhookTypeDirective implements OnInit {

  @Input() webhookType: WebhookType ;

  constructor(private element: ElementRef<HTMLElement>) { }

  ngOnInit(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {

    let classList = "badge tw-font-bold border tw-w-[78px] ";

    switch (this.webhookType) {
      case WebhookType.Delivery:
        classList += "badge-light-warning border-warning"
        break;
      case WebhookType.Receive:
        classList += "badge-light-navyBlue border-navyBlue"
        break;
      default:
        break;
    }

    return classList;
  }

}

